import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { ArrowLeft, Upload, Trash2 } from 'lucide-react';
import PanelButton from '../PanelButton';
import AvailableDocuments from '../AvailableDocuments';

const SectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #e0e0e0;
  margin: 0 0 0.75rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const ScansPanelContent = ({
  loanId,
  onShowDeleteModal,
  documentsByType,
  onPreviewDocument,
  onToggleMute,
  showAutoPopulate,
  autoPopulateExpanded,
  onToggleAutoPopulate
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <button 
          onClick={() => navigate(`/document-analysis/${loanId}`)}
          style={{
            background: 'none',
            border: 'none',
            color: '#e0e0e0',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.color = '#ffffff'}
          onMouseLeave={(e) => e.target.style.color = '#e0e0e0'}
        >
          <ArrowLeft size={16} />
          Back
        </button>
      </div>

      <AvailableDocuments
        documentsByType={documentsByType}
        onPreviewDocument={onPreviewDocument}
        onToggleMute={onToggleMute}
        showAutoPopulate={showAutoPopulate}
        autoPopulateExpanded={autoPopulateExpanded}
        onToggleAutoPopulate={onToggleAutoPopulate}
      />
      
      <div style={{ 
        marginTop: '1rem',
        paddingTop: '1rem',
        borderTop: '1px solid #4a4a4a',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }}>
        <PanelButton onClick={() => navigate(`/document-analysis/${loanId}/scans`)}>
          <Upload size={16} />
          Upload Files
        </PanelButton>
        
        <PanelButton
          deleteMode={true}
          onClick={onShowDeleteModal}
        >
          <Trash2 size={16} />
          Permanently Delete Results
        </PanelButton>
      </div>
    </>
  );
};

export default ScansPanelContent;
